var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 54,
    viewBox: "0 0 57 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1204_155)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 41.25,
    height: 38.5,
    rx: 7.33333,
    fill: "#ECECEC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 17,
    height: 28,
    rx: 1,
    fill: "#2E5C33"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.75,
    cy: 34.75,
    r: 0.75,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 13,
    width: 15,
    height: 20,
    rx: 0.5,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11.5,
    width: 5,
    height: 0.8,
    rx: 0.4,
    fill: "#ECECEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1204_155",
    x: 0.25,
    y: 0.333333,
    width: 55.9167,
    height: 53.1667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.58333,
    dy: 3.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1204_155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1204_155",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone4);
export default __webpack_public_path__ + "static/media/phone 4.df5fcea6094317e74c988cbb92e7b882.svg";
export { ForwardRef as ReactComponent };